import React, { useContext } from 'react';
import {
  params, useDataModel, extend,
  number as numberType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import classNames from 'classnames';
import {
  Card,
  CardTitle,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { Duplicate } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const CopyListTile = ({ }) => {
  const {
    setScreen
  } = useContext(AddToContext);
  const { data: listsData } = useDataModel('lists', {
    variables: {},
    context: { withAuth: true }
  });
  const isListsTileEnabled = listsData?.lists?.pagination?.totalResults > 1;

  const handleTileClick = () => {
    // 7.1 Copy from Your Lists selection - when drawer opens
    triggerAnalytics(TRACK.ADD_TO_LIST_COPY_FROM_LISTS_SELECTION);
    setScreen('COPY_LIST_SUMMARY');
  };

  const copyListTileWrapperClass = classNames(
    'sui-mt-8 sui-cursor-pointer sui-bg-subtle',
    {
      'sui-pointer-events-auto': isListsTileEnabled,
      'sui-pointer-events-none': !isListsTileEnabled
    }
  );
  return (
    <div
      onClick={handleTileClick}
      className={copyListTileWrapperClass}
    >
      <Card data-testid="copy-list" disablePadding disableGutters orientation="horizontal" className={`${isListsTileEnabled ? null : 'sui-bg-subtle'}`}>
        <div className="sui-w-24 sui-flex sui-justify-center sui-items-center">
          <Duplicate size="large" color={isListsTileEnabled ? 'primary' : 'subtle'} />
        </div>
        <div className="sui-py-3 sui-pr-1">
          <CardTitle
            header={(
              <Typography
                variant="h3"
                color={isListsTileEnabled ? 'primary' : 'inactive'}
              >
                Copy from Your Lists
              </Typography>
            )}
          />
          <CardBody>
            <Typography
              color={isListsTileEnabled ? null : 'inactive'}
            >
              Pull in items from one or more of your existing lists.
            </Typography>
          </CardBody>
        </div>
      </Card>
    </div>
  );
};

CopyListTile.displayName = 'CopyListTile';

CopyListTile.propTypes = {};

CopyListTile.defaultProps = {};

CopyListTile.dataModel = extend({
  lists: params({ page: numberType(), pageSize: numberType() }).shape({
    pagination: shapeType({
      totalResults: numberType(),
    })
  })
});
